/* Editorial Product Grid — matches Media/Text filler block height to the
   rendered height of the product row that precedes it (by product index),
   even when the filler renders in a different grid row than its reference
   product. Hook: .editorial-product-grid.

   On mobile, a filler configured to span only 1 of the 2 mobile columns is a
   special case: it must not grow taller than the *media* area of the product
   beside it (not the whole card, which also includes title/price) — so on
   mobile that specific case caps min/max-height to the reference product's
   media element instead of matching the full card height. Every other case
   (desktop, or a mobile filler spanning both columns) keeps the original
   full-card min-height match unchanged. */
(function () {
  var MOBILE_QUERY = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function getReferenceItem(root, insertAfter) {
    var items = root.querySelectorAll('.epg__item[data-product-index]');
    var match = null;

    for (var i = 0; i < items.length; i++) {
      var idx = parseInt(items[i].getAttribute('data-product-index'), 10);
      if (isNaN(idx)) continue;
      if (idx === insertAfter) return items[i];
      if (idx < insertAfter) match = items[i];
    }

    return match;
  }

  function applyHeights(root) {
    var fillers = root.querySelectorAll('.epg__filler[data-insert-after-product]');
    var mobile = isMobile();

    for (var i = 0; i < fillers.length; i++) {
      var filler = fillers[i];

      /* On mobile, a filler can be positioned relative to a DIFFERENT product
         than on desktop (data-insert-after-product-mobile, independent of
         data-insert-after-product — see editorial-product-grid-filler.liquid).
         Height matching should reference whichever one is actually relevant
         for the current breakpoint. */
      var insertAfterAttr = mobile ? 'data-insert-after-product-mobile' : 'data-insert-after-product';
      var insertAfter = parseInt(filler.getAttribute(insertAfterAttr), 10);
      if (isNaN(insertAfter)) {
        insertAfter = parseInt(filler.getAttribute('data-insert-after-product'), 10);
      }

      /* 0 (or unset) means the filler has no preceding product row to match. */
      if (!insertAfter || insertAfter < 1) continue;

      var reference = getReferenceItem(root, insertAfter);
      if (!reference) continue;

      var mobileSpan = parseInt(filler.getAttribute('data-column-span-mobile'), 10);
      var capToMedia = mobile && mobileSpan === 1;

      if (capToMedia) {
        var mediaEl = reference.querySelector('.product-card-media');
        var mediaHeight = mediaEl ? mediaEl.getBoundingClientRect().height : 0;
        if (mediaHeight > 0) {
          filler.style.minHeight = mediaHeight + 'px';
          filler.style.maxHeight = mediaHeight + 'px';
        }
      } else {
        /* Clears any media-height cap left over from a previous mobile
           single-column measurement (e.g. after a resize back to desktop,
           or to a 2-column mobile span) before falling back to the normal
           full-card match. */
        filler.style.maxHeight = '';
        var height = reference.getBoundingClientRect().height;
        if (height > 0) {
          filler.style.minHeight = height + 'px';
        }
      }
    }
  }

  function observeReferences(root) {
    if (typeof ResizeObserver === 'undefined') return null;

    var observer = new ResizeObserver(function () {
      applyHeights(root);
    });

    var items = root.querySelectorAll('.epg__item[data-product-index]');
    for (var i = 0; i < items.length; i++) {
      observer.observe(items[i]);
    }

    return observer;
  }

  function initGrid(root) {
    if (!root || root.dataset.epgInit === '1') return;
    root.dataset.epgInit = '1';

    applyHeights(root);
    root.epgResizeObserver = observeReferences(root);

    /* Fonts/lazy images can still shift card height after DOMContentLoaded. */
    if (document.readyState !== 'complete') {
      window.addEventListener('load', function () { applyHeights(root); }, { once: true });
    }

    /* Fallback for browsers without ResizeObserver — covers viewport/breakpoint changes. */
    if (!root.epgResizeObserver) {
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { applyHeights(root); }, 150);
      });
    }
  }

  function destroyGrid(root) {
    if (!root) return;
    if (root.epgResizeObserver) {
      root.epgResizeObserver.disconnect();
      root.epgResizeObserver = null;
    }
    root.dataset.epgInit = '';
  }

  function boot() {
    var nodes = document.querySelectorAll('.editorial-product-grid');
    for (var i = 0; i < nodes.length; i++) {
      initGrid(nodes[i]);
    }
  }

  function recalcAll() {
    var nodes = document.querySelectorAll('.editorial-product-grid');
    for (var i = 0; i < nodes.length; i++) {
      applyHeights(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('.editorial-product-grid')
      : null;
    destroyGrid(root);
  });

  /* card_media area height is normally fixed by its own aspect-ratio, so a
     swatch-driven media swap (assets/card-product-color-swatches.js) doesn't
     usually change it — but this keeps the mobile media-height cap correct
     in case it ever does. */
  document.addEventListener('epg:media-updated', recalcAll);
})();
